export default __webpack_public_path__ + "static/ShareSection2_es-9f24b0c22cc8a458b04e2132b54a9ea5.png";